import { QuestionStatus } from '@report/graphql';
import { type GridColDef, Label, LabelColor, Text } from '@shared/components';
import { formatDateTh } from '@shared/utils';

export interface QBankOverviewListItem {
  id: string;
  order: number;
  code: string;
  firstPublishedAt: Date;
  lastPublishedAt: Date;
  type: boolean;
  status: QuestionStatus;
  pInitial: string;
  pUse: string;
  bIndexInitial: string | null;
  answer: string;
}

const QUESTION_STATUS_COLOR: Record<QuestionStatus, LabelColor> = {
  [QuestionStatus.Published]: LabelColor.SUCCESS,
  [QuestionStatus.Disabled]: LabelColor.GREY,
};

const QUESTION_STATUS_TEXT: Record<QuestionStatus, string> = {
  [QuestionStatus.Published]: 'Published',
  [QuestionStatus.Disabled]: 'Disabled',
};

export const columns: GridColDef<QBankOverviewListItem>[] = [
  {
    field: 'order',
    headerName: 'No.',
    width: 64,
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    renderCell: ({ row }) => {
      return <Text>{row.order}</Text>;
    },
  },
  {
    field: 'code',
    headerName: 'QID',
    sortable: false,
    flex: 1,
    renderCell: ({ row }) => {
      return <Text>{row.code}</Text>;
    },
  },
  {
    field: 'firstPublishedAt',
    headerName: 'First Pub.',
    width: 110,
    sortable: false,
    renderCell: ({ row }) => {
      return <Text>{formatDateTh(row.firstPublishedAt)}</Text>;
    },
  },
  {
    field: 'lastPublishedAt',
    headerName: 'Last Pub.',
    width: 110,
    sortable: false,
    renderCell: ({ row }) => {
      return <Text>{formatDateTh(row.lastPublishedAt)}</Text>;
    },
  },
  {
    field: 'type',
    headerName: 'Type',
    width: 100,
    sortable: false,
    renderCell: ({ row }) => {
      return <Text>{row.type ? 'คำนวณ' : 'ไม่คำนวณ'}</Text>;
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 100,
    sortable: false,
    renderCell: ({ row }) => {
      return (
        <Label color={QUESTION_STATUS_COLOR[row.status]}>{QUESTION_STATUS_TEXT[row.status]}</Label>
      );
    },
  },
  {
    field: 'pInitial',
    headerName: 'P Initial',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    renderCell: ({ row }) => {
      return <Text>{row.pInitial}</Text>;
    },
  },
  {
    field: 'pUse',
    headerName: 'P Use',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    renderCell: ({ row }) => {
      return <Text>{row.pUse}</Text>;
    },
  },
  {
    field: 'bIndexInitial',
    headerName: 'B-Index (Initial)',
    width: 136,
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    renderCell: ({ row }) => {
      return <Text>{row.bIndexInitial ?? '-'}</Text>;
    },
  },
  {
    field: 'answer',
    headerName: 'Answer',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    renderCell: ({ row }) => {
      return <Text>{row.answer}</Text>;
    },
  },
];
